export const faqs = [
  {
    question: '久久综合平台提供哪些类型的内容资源？',
    answer: '久久综合平台汇集了影视资源、音乐天地、图文精选、资讯快报、学习资料和软件工具等六大类内容资源，覆盖您日常生活和工作中的全方位需求。我们持续更新内容，确保您始终能获取最新、最优质的资源信息。',
  },
  {
    question: '久久综合的内容多久更新一次？',
    answer: '久久综合平台的内容保持每日更新，我们的编辑团队全天候关注各领域的最新动态，确保您能在第一时间获取到新鲜、有价值的内容。热门分类如资讯快报每天更新多次，其他分类至少每天更新一次。',
  },
  {
    question: '在久久综合平台上可以搜索到哪些内容？',
    answer: '久久综合平台提供强大的全文搜索功能，您可以通过关键词搜索到平台上的所有内容，包括文章标题、正文内容、标签和分类信息。搜索功能支持模糊匹配，即使您不记得完整的关键词也能找到相关内容。',
  },
  {
    question: '久久综合平台是否免费使用？',
    answer: '是的，久久综合平台对所有用户完全免费开放。我们致力于为用户提供优质的内容聚合服务，不收取任何费用。您可以免费浏览所有内容、使用搜索功能、收藏感兴趣的文章。',
  },
  {
    question: '如何在久久综合平台上找到感兴趣的内容？',
    answer: '您可以通过多种方式在久久综合平台上发现感兴趣的内容：使用顶部导航栏浏览不同分类；在首页查看精选推荐和热门内容；使用搜索框输入关键词进行精确查找。每个分类页面都提供了丰富的筛选和排序选项。',
  },
  {
    question: '久久综合的内容来源可靠吗？',
    answer: '久久综合高度重视内容质量，所有发布的内容都经过专业编辑团队的审核和筛选。我们严格把关信息来源的可靠性和内容的准确性，确保为您提供值得信赖的优质内容。',
  },
];